import { AUTO_CONFIG_REMOVED } from './reviewStates';

const NOT_REVIEWED = 'Not reviewed';

/**
 * The state to show for one issue.
 *
 * Order is load-bearing: a stored human state always wins over a computed
 * auto-mark. The backend already excludes human-touched issues from the
 * overlay, so this is belt and braces — but the rule must hold here too,
 * because a UI that can display a computed verdict over a human decision is
 * a UI reviewers stop trusting.
 */
export function effectiveState(issueId, humanStates, overlaySection) {
  const human = humanStates && humanStates[issueId];
  if (human) {
    return { value: human.value || NOT_REVIEWED, isAuto: false, components: [] };
  }
  const auto = overlaySection && overlaySection[issueId];
  if (auto) {
    return {
      value: auto.state || AUTO_CONFIG_REMOVED,
      isAuto: true,
      components: auto.components || []
    };
  }
  return { value: NOT_REVIEWED, isAuto: false, components: [] };
}

/**
 * The partial-enablement hint for one issue, if any.
 *
 * These issues are never auto-marked — the hint exists to explain why an
 * issue for a mostly-unused component is still in the list.
 */
export function partialHintFor(issueId, hintSection) {
  const hints = hintSection && hintSection[issueId];
  if (!Array.isArray(hints) || hints.length === 0) return null;
  return hints[0];
}
